function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1-Copy",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "v2--Configure-Search---Iteration-3-(10)",
  transform: "translate(-1129.000000, -429.000000)",
  fill: "#009435"
}, /*#__PURE__*/React.createElement("g", {
  id: "basic",
  transform: "translate(274.000000, 205.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(24.000000, 29.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "search/basic"
}, /*#__PURE__*/React.createElement("g", {
  id: "mm-combo-copy-9",
  transform: "translate(289.000000, 189.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons/info-material",
  transform: "translate(540.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.46666667,6.4 L8.53333333,6.4 L8.53333333,5.33333333 L7.46666667,5.33333333 M8,12.2666667 C5.648,12.2666667 3.73333333,10.352 3.73333333,8 C3.73333333,5.648 5.648,3.73333333 8,3.73333333 C10.352,3.73333333 12.2666667,5.648 12.2666667,8 C12.2666667,10.352 10.352,12.2666667 8,12.2666667 M8,2.66666667 C5.05448133,2.66666667 2.66666667,5.05448133 2.66666667,8 C2.66666667,9.41448795 3.22856982,10.7710421 4.22876383,11.7712362 C5.22895785,12.7714302 6.58551205,13.3333333 8,13.3333333 C10.9455187,13.3333333 13.3333333,10.9455187 13.3333333,8 C13.3333333,5.05448133 10.9455187,2.66666667 8,2.66666667 M7.46666667,10.6666667 L8.53333333,10.6666667 L8.53333333,7.46666667 L7.46666667,7.46666667 L7.46666667,10.6666667 Z",
  id: "Icon-Shape"
})))))))));

var SvgInfoCircleLight = function SvgInfoCircleLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoCircleLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/infoCircleLight.0df07c65.svg";
export { ForwardRef as ReactComponent };